module.exports = __webpack_public_path__ + "static/img/LOGO-ROSA-XIMENA-transparent.403d2c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LOGO-ROSA-XIMENA-transparent.png
// module id = iMWe
// module chunks = 0